var _style, _g, _defs, _defs2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTopography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:#020301;}\r\n\t.st8{clip-path:url(#SVGID_2_);}\r\n\t.st9{clip-path:url(#SVGID_4_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210,
    y1: 0,
    x2: 210,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 220,
    y1: 0,
    x2: 220,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270,
    y1: 0,
    x2: 270,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280,
    y1: 0,
    x2: 280,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290,
    y1: 0,
    x2: 290,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 10,
    x2: 320,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 20,
    x2: 320,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 30,
    x2: 320,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 40,
    x2: 320,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 50,
    x2: 320,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 70,
    x2: 320,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 80,
    x2: 320,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 90,
    x2: 320,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110,
    x2: 320,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 130,
    x2: 320,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 140,
    x2: 320,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 150,
    x2: 320,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 160,
    x2: 320,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 170,
    x2: 320,
    y2: 170
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 180,
    x2: 320,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 190,
    x2: 320,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 200,
    x2: 320,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 210,
    x2: 320,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 220,
    x2: 320,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 230,
    x2: 320,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 240,
    x2: 320,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 320,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 260,
    x2: 320,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 270,
    x2: 320,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 280,
    x2: 320,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 290,
    x2: 320,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 300,
    x2: 320,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 310,
    x2: 320,
    y2: 310
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M183.6,234.7c-3.4-2.1-8.5-6-14.5-10.7c7.7-5.8,15.1-11.4,21.2-16c7.6,8.4,14.4,14.7,20.7,19.1L192.2,240 L183.6,234.7z M96.1,101.7c3.1,3.7,8.5,8.6,17.4,12.7c-1.4,1-2.9,2-4.2,3c-3.8,2.8-8.9,6.5-14.6,10.8 c-9.1-2.7-16.3-7.4-20.9-11.2L96.1,101.7z M191.7,191.4c-6.8-8.2-14.3-18-22.7-30c-1.5-2.1-2.9-4-4.2-5.8 c6.1-7.7,12.8-12.1,23.3-13.1c0.2,0.3,0.4,0.5,0.5,0.8c6.5,9.9,14.6,22.1,24.7,33.7c-8.6,5.2-14.6,9-17,10.9 C195.3,188.7,193.7,189.9,191.7,191.4z M127.8,191.5c-7.1-5.3-14.2-10.2-20.9-14.3c3.2-4.1,6.2-8.6,8.9-13.7l0.7-1.4 c4-7.6,7.5-14,11-19.5c7.2,0,13,2.3,22.6,13.5c-2.6,4.1-5.1,8.5-7.8,13.2c-1.7,2.9-3.5,6-5.4,9.3 C134.1,183.3,131,187.6,127.8,191.5z M120.2,129.9c-2.3,0.2-4.9,0.3-7.7,0.4c0.8-0.6,1.7-1.2,2.4-1.8c4.1-3,8.8-6.1,13.8-9.2 c0.8,0.2,1.6,0.3,2.5,0.5c-3.3,2.9-6.2,6.2-9,10C121.5,129.8,120.9,129.8,120.2,129.9z M195.5,129.2c-0.8,0-1.6,0-2.3,0 c-2.3-3.5-4.5-6.5-6.5-9.1c0.6-0.1,1.1-0.2,1.7-0.4c5.4,3.5,10.4,6.7,15,9.7C201,129.4,198.4,129.3,195.5,129.2z M175.2,125.1 c1.4,1.3,3,3.3,4.7,5.6c-9.6,2.5-16.6,8-22.7,15.5c-7.9-9.1-14-13.5-20.2-15.4c6.8-6.2,15.1-9.6,27.9-10.2 C168.8,121.3,172.5,122.6,175.2,125.1z M202,142.5c7.7,0.2,13.8-0.1,19.2-1.1c0.4,0.3,0.8,0.6,1.1,0.8 c2.2,1.7,10.7,8.5,20.9,16.4c-6.8,4.2-13.6,8.4-19.6,12C215.2,161.6,208.1,151.7,202,142.5z M235.3,136.8 c5.8-3,11.9-7.5,19.7-13.9l21.2,14.5c-5.5,4-13.3,9.1-21.8,14.4C248,146.8,241.4,141.6,235.3,136.8z M223.2,127.6 c-4.8-3.3-11.9-8-20.1-13.3c5.9-2.9,12.7-7.2,19.8-13.3l21.4,14.6C236.1,122.1,230.1,125.7,223.2,127.6z M190,105.8 c-6.4-4.1-13-8.3-19.4-12.4c7.1-4.7,13.7-9.6,19.7-14.7l22.1,15C203.5,100.5,195.7,104,190,105.8z M169.3,107.5 c-1.4,0-2.7,0-4,0.1c-8.3-1.1-15.9,0.4-18.3,0.9c-0.2,0-0.3,0-0.5,0c4.2-2.5,8.3-5,12.4-7.6C162.4,103.1,165.9,105.3,169.3,107.5 z M139.2,98.2c-4.1,2.5-8.2,4.9-12.1,7.3c-10.7-2.9-17.3-7.3-21-10.7l20.7-14.1c6,3.8,12.9,8.1,20.2,12.7 C144.5,95,141.9,96.6,139.2,98.2z M82.4,137.2c-6.1,4.5-12.4,9.3-18.5,13.9c-8.1-5.2-15.2-10-20.4-13.5L63.3,124 C66.9,127.5,73.4,132.9,82.4,137.2z M96.5,142.1c2.9,0.6,6,1.1,9.2,1.3c2.9,0.1,5.5,0.1,7.9,0.1c-2.1,3.6-4.1,7.5-6.3,11.6 l-0.7,1.4c-3,5.6-6.4,10.5-10.1,14.8c-7-4-14.3-8.5-21.5-13C82.3,152.7,89.8,147.2,96.5,142.1z M87.3,180.5 c-10.2,8.9-20,13.6-24.2,15.4L43,182.2c5.3-4,12.8-9.6,21.2-15.9C71.7,171,79.7,176,87.3,180.5z M98.4,186.8 c6.6,3.7,13.7,8.5,21,13.8c-9.7,9.5-19,15.3-23.2,17.7l-20.9-14.3C81.7,200.6,90.1,195,98.4,186.8z M129.1,208 c6.8,5.2,13.6,10.6,19.8,15.7c-9.3,7-17.4,13.1-21.4,16.1l-20.1-13.7C113.4,222.2,121.2,216.2,129.1,208z M158.4,215.5 c-6.6-5.3-13.8-11.1-21.1-16.8c3-3.8,5.9-7.9,8.5-12.4c1.9-3.3,3.8-6.4,5.5-9.4c2.3-4,4.4-7.6,6.4-10.9c0.9,1.3,1.9,2.6,2.9,4 c7.9,11.2,15,20.6,21.6,28.6c-6.7,5.1-14.9,11.3-23.1,17.4C158.9,215.8,158.7,215.7,158.4,215.5z M199.8,200.8 c1-0.7,1.7-1.3,2.3-1.7c2.3-1.8,10.2-6.6,20-12.6c2.3,2.3,4.7,4.5,7.3,6.6c0.3,0.3,6.4,6.2,14.5,11.6l-21.5,14.7 C215.7,216,208.4,210,199.8,200.8z M235.9,182.6c-1.1-0.9-2-1.8-3.1-2.7c7.4-4.5,14.5-8.9,21-12.9c7.9,6.1,15.7,12,21.6,16.2 l-20.1,13.7C245.2,191.5,236.3,183,235.9,182.6z M265,159.9c9.6-6.2,17.2-11.4,22-15.3l22.5,15.4l-23.1,15.7 C282.6,173.2,274.6,167.2,265,159.9z M179.8,71.6c-6.3,5-13.4,9.8-20.8,14.5c-8.2-5.2-15.4-9.8-20.8-13.1L160,58.1L179.8,71.6z  M32.3,145.1c3.8,2.6,11.4,7.8,20.8,14c-9.2,6.9-17,12.8-20.9,15.7L10.5,160L32.3,145.1z M138.4,247.2c5.2-4,12.6-9.5,20.6-15.5 c8.1,6.5,15,11.9,19.7,14.7l2.2,1.3L160,261.9L138.4,247.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 10.5,
    y: 58.1,
    width: 299.4,
    height: 219.5
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -89.3,
    y: -41.7,
    className: "st9",
    width: 498.6,
    height: 403.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopography);
export default __webpack_public_path__ + "static/media/Icon_Topography.c292377295a87fd44b6b50f54aaf1a7d.svg";
export { ForwardRef as ReactComponent };